import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ModulesList from './modules/list';
import WidgetCustom from './widget-custom';
import StepsList from './stepsList';
import FormWidgetSteps from './widgetSteps/formWidgetSteps';

import NewWidget from './components/pages/new-widget';
import EditWidget from './components/pages/edit-widget';
import NewFilteredWidget from './components/pages/filtered-widget';
import EditFilteredWidget from './components/pages/filtered-widget-edit';
import WidgetCustomOrganization from './components/widget-custom/widget-custom-page';
import AuthRoute from '../../utils/authRoute';
import { ManagerContextProvider } from '../manager/components/context';
import PageError from '../error/pageError';

export default class Widgets extends React.Component {
    render() {
        const { path } = this.props;
        return (
            <ManagerContextProvider>
                <Switch>
                    <Route
                        exact
                        path={`${path}/neo/new`}
                        render={props => {
                            return <FormWidgetSteps organizationId={this.props.organizationId} path={props.match.path} widgetId={null} history={props.history} />;
                        }}
                    />
                    {/* Does not use "exact" because we have another route under it */}
                    <Route
                        path={`${path}/:widgetId/steps`}
                        render={props => {
                            return <StepsList organizationId={this.props.organizationId} path={props.match.path} widgetId={props.match.params.widgetId} />;
                        }}
                    />
                    {/* Customs */}
                    <Route
                        path={`${path}/:widgetId/customs`}
                        render={({
                            match: {
                                params: { widgetId, id }
                            },
                            history
                        }) => <WidgetCustom widgetId={widgetId} history={history} />}
                    />
                    <Route exact path={`${path}/`} render={() => <ModulesList organizationId={this.props.organizationId} />} />
                    <Route exact path={`${path}/new`}>
                        <NewWidget />
                    </Route>
                    <Route exact path={`${path}/:widget_id([0-9]+)`}>
                        <EditWidget />
                    </Route>
                    <Route exact path={`${path}/filtered/new`}>
                        <NewFilteredWidget />
                    </Route>
                    <Route exact path={`${path}/filtered/:widget_id([0-9]+)`}>
                        <EditFilteredWidget />
                    </Route>
                    <AuthRoute exact path={`${path}/customs`} fallback={<PageError errorCode={403} backHomeUrl={`/ticket/O${this.props.organizationId}`} />}>
                        <WidgetCustomOrganization />
                    </AuthRoute>
                    {/* Error */}
                    <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${this.props.organizationId}`} />} />
                </Switch>
            </ManagerContextProvider>
        );
    }
}

Widgets.propTypes = {
    connect: PropTypes.object.isRequired,
    organizationId: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
};
